import { Box, Button, Flex, Input, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { loginAPI } from '../service/AuthService';
import { Encrypt } from '../utils/constants';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
export default function Login() {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      login();
    }
  };

  const login = async () => {
    const { response, message, code } = await loginAPI(
      userName,
      Encrypt(password)
    );
    if (userName === '' || password === '') {
      toast.error('Please enter username and password');
      return;
    }
    if (code == 200) {
      dispatch({
        type: 'accountData/setUserData',
        payload: response,
      });

      window.location.href = '/admin';
      console.log(response, "login response")
    } else {
      toast.error(response);
    }
  };
  return (
    <Flex direction='column' className='login_container'>
      <Box className='login_logo'>
        <img src={require('../assets/img/logo-white.png')} alt='Logo' />
      </Box>
      <Flex
        direction='column'
        className='login_box'
      >
        <h2>LOGIN</h2>

        <Text className='login_label'>Username</Text>
        <Input
          onKeyDown={handleKeyDown}
          onChange={(e) => setUserName(e.target.value)}
          placeholder='Enter Username'
          className='login_input'
        />

        <Text className='login_label'>Password</Text>
        <Input
          onKeyDown={handleKeyDown}
          onChange={(e) => setPassword(e.target.value)}
          placeholder='Enter Password'
          type='password'
          className='login_input'
        />

        <Button
          onKeyDown={handleKeyDown}
          onClick={login}
          className='login_button'
        >
          LOGIN
        </Button>
      </Flex>
    </Flex>
  );
}
